var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Remove Driver") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 10.9375 0 10.9375 5.09675 0 5.09675"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Remove-Driver",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 6.323650)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9975,2.17175 C7.4565,2.27075 8.0385,2.48175 8.7245,2.80075 C8.7825,2.82775 8.8235,2.86475 8.8585,2.92175 C8.8905,2.97475 8.9095,3.02375 8.9135,3.07375 L2.0235,3.07375 C2.0285,3.01775 2.0445,2.96675 2.0785,2.91075 C2.1085,2.85875 2.1445,2.82575 2.1955,2.80175 C2.8835,2.48175 3.4665,2.27075 3.9305,2.17175 C4.8675,1.97475 6.0715,1.97275 6.9975,2.17175 M10.5735,1.83475 C10.3315,1.45875 9.9885,1.16875 9.5485,0.96775 C8.7525,0.61775 8.0325,0.36675 7.4075,0.22175 C6.1435,-0.07425 4.8025,-0.07325 3.5225,0.22075 C2.8915,0.36675 2.1675,0.61775 1.3805,0.96475 C0.9355,1.15375 0.5885,1.44775 0.3495,1.83675 C0.1175,2.21475 -0.0005,2.63975 -0.0005,3.10175 L-0.0005,4.08475 C-0.0005,4.36475 0.0995,4.61375 0.2915,4.80475 C0.4815,4.99575 0.7315,5.09675 1.0105,5.09675 L9.9255,5.09675 C10.2055,5.09675 10.4545,4.99575 10.6445,4.80675 C10.8355,4.61575 10.9375,4.36575 10.9375,4.08475 L10.9375,3.10175 C10.9375,2.63675 10.8155,2.21075 10.5735,1.83475",
    id: "Fill-1",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.8667,2.253 C5.0237,2.096 5.2157,2.022 5.4687,2.022 C5.7217,2.022 5.9137,2.096 6.0707,2.253 C6.2287,2.41 6.3017,2.602 6.3017,2.856 C6.3017,3.109 6.2287,3.3 6.0707,3.457 L6.0697,3.458 C5.7567,3.773 5.1817,3.774 4.8667,3.457 C4.7087,3.3 4.6347,3.109 4.6347,2.856 C4.6347,2.602 4.7087,2.411 4.8667,2.253 M7.5177,0.806 L7.5177,0.806 C6.9827,0.271 6.2937,0 5.4687,0 C4.6447,0 3.9547,0.271 3.4187,0.806 C2.8837,1.342 2.6127,2.031 2.6127,2.856 C2.6127,3.68 2.8837,4.369 3.4187,4.905 C3.9557,5.44 4.6447,5.712 5.4687,5.712 C6.2927,5.712 6.9827,5.44 7.5177,4.905 C8.0527,4.37 8.3247,3.681 8.3247,2.856 C8.3247,2.031 8.0527,1.342 7.5177,0.806",
    id: "Fill-4",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1496,5.9262 L9.3936,5.9262 C8.9236,5.9262 8.5426,5.5452 8.5426,5.0752 C8.5426,4.6052 8.9236,4.2242 9.3936,4.2242 L13.1496,4.2242 C13.6196,4.2242 13.9996,4.6052 13.9996,5.0752 C13.9996,5.5452 13.6196,5.9262 13.1496,5.9262",
    id: "Fill-6",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.19d2bd0e0f8a85eb746e1983e4f432c2.svg";
export { ForwardRef as ReactComponent };